/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

//import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';

// import { getLatestProductsAsync } from '../../actions/DataActionExtension.g';
import { getProductListFromCuratedList } from './components/curated-product-list.component';
//import { IProductCard } from './components/eshop-product-card';
import { IGridSettings } from '@msdyn365-commerce/core-internal';

import { IEshopFeaturedProductsData } from './eshop-featured-products.data';
import { IEshopFeaturedProductsProps } from './eshop-featured-products.props.autogenerated';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

export interface IEshopFeaturedProductsViewProps extends IEshopFeaturedProductsProps<IEshopFeaturedProductsData> {
    productList: SimpleProduct[];
    gridSettings: IGridSettings;
}

/**
 *
 * EshopFeaturedProducts component
 * @extends {React.PureComponent<IEshopFeaturedProductsProps<IEshopFeaturedProductsData>>}
 */
class EshopFeaturedProducts extends React.PureComponent<IEshopFeaturedProductsProps<IEshopFeaturedProductsData>> {
    public state = { productList: [], existingMonths: [], mobileProducts: [] };

    public async componentDidMount() {
        const {
            data: {}
        } = this.props;

        // const language = this.props.context.request.locale.split('-')[0];

        const data = await getProductListFromCuratedList(this.props);
        this.setState({ productList: data.productsSimpleDetails });
    }

    public render(): JSX.Element | null {
        const IEshopFeaturedProductsViewProps = {
            ...this.props,
            productList: this.state['productList']
        };

        return this.props.renderView(IEshopFeaturedProductsViewProps);
    }
}

export default EshopFeaturedProducts;
